import apiFetch from '../apiFetch'

export default function (tokenAnalisisMagavision) {			
	return apiFetch({endPoint: `MagavisionML/comprobarArchivoML?tokenAnalisisMagavision=${tokenAnalisisMagavision}`, method: 'GET', body:null, mode: 'cors', credentials: 'omit'})	
}
